const RedirectKey = 'accounts-redirect';

export function setAuthRedirect(path: string) {
    sessionStorage.setItem(RedirectKey, path);
}

export function getAuthRedirect() {
    return sessionStorage.getItem(RedirectKey) ?? '/';
}
